import script from "./TabContainer.vue?vue&type=script&lang=ts"
export * from "./TabContainer.vue?vue&type=script&lang=ts"

import "./tab-container.scss?vue&type=style&index=0&id=332ad692&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332ad692"]])

export default __exports__